import { API_GET_ONE_PROFESSIONAL_UNIT_SUCCESS } from '../actions/ProfessionalUnitActions';
const INITIAL_STATE = {};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, payload, type }) => {
    switch (type) {
        case API_GET_ONE_PROFESSIONAL_UNIT_SUCCESS: {
            return {
                [meta.id]: payload,
            };
        }
        default: {
            return state;
        }
    }
};
